import { PERMS } from "authz/perms.generated";
import { decryptWithAES, encryptWithAES } from "utils/parse";
import http from "../../index";
import { PaginationResponse } from "types";
import { Admin, AuthLog, AuthLogFilter, LoginData, LoginResponse, SsoCallbackData, SsoConfig, SsoStart } from "./types";

namespace auth {
  const userKey = "app.user";
  const tokenKey = "app.token";
  const orgKey = "org.id";
  const isFilterOrgKey = "is_filter_org";

  export const saveToken = (token: string) => {
    localStorage.setItem(tokenKey, token);
  };

  export const rememberUser = (values: LoginData) => {
    if (values.remember) {
      localStorage.setItem(userKey, encryptWithAES(JSON.stringify(values)));
    } else {
      localStorage.removeItem(userKey);
    }
  };

  export const getRememberUser = () => {
    const userData = localStorage.getItem(userKey);
    if (userData) {
      const _userData = JSON.parse(decryptWithAES(userData)) as LoginData;
      return _userData;
    }
    return undefined;
  };

  export const remToken = () => {
    localStorage.removeItem(tokenKey);
  };

  export const hasToken = () => !!localStorage.getItem(tokenKey);

  export const getToken = () => localStorage.getItem(tokenKey);

  export const setIsFilterOrg = (isFilter: string) => {
    localStorage.setItem(isFilterOrgKey, isFilter);
  };

  export const getIsFilterOrg = () => localStorage.getItem(isFilterOrgKey);

  export const setOrg = (id: string | undefined) => {
    if (id) localStorage.setItem(orgKey, id);
  };

  export const getOrg = () => localStorage.getItem(orgKey);

  export const info = () =>
    http.get<Admin>("/admin/auth/info", { hasAuth: true });

  export const login = (body: LoginData) =>
    http.post<LoginResponse>("/admin/auth/login", {
      body,
    });

  export const ssoConfig = () => http.get<SsoConfig>("/admin/auth/sso/config");

  export const ssoStart = () => http.post<SsoStart>("/admin/auth/sso/start");

  export const ssoCallback = (body: SsoCallbackData) =>
    http.post<LoginResponse>("/admin/auth/sso/callback", { body });

  export const logs = {
    call: (body: AuthLogFilter) => {
      return http.post<PaginationResponse<AuthLog>>("/admin/auth/logs/page", {
        hasAuth: true,
        body,
      });
    },
    permission: PERMS.USER_READ,
  };
}

export default auth;
